/* suoni.js · motore dei suoni per siti e pagine di marca (creative-os, 23/10/2026)
   Regole: ../references/suono.md. Collaudo: suono.py nella stessa cartella.
   Niente parte da solo: il contesto audio nasce al tocco sull'interruttore e i file si scaricano solo allora.
   Web Audio e non elementi <audio>: cosi' l'iPhone col silenzioso resta zitto e la musica di chi legge non si ferma.

   Uso minimo:
     <button type="button" data-suono-interruttore aria-pressed="false"
             data-testo-spento="Accendi i suoni" data-testo-acceso="Spegni i suoni">Accendi i suoni</button>
     <script src="suoni.js" defer></script>
     <script>
       document.addEventListener('DOMContentLoaded', function () {   // i defer girano prima di questo evento
         var S = Suoni.crea({ conferma: 'lume', ambiente: 'notte', file: { libro: 'suoni/libro.mp3' },
                              ricette: { firma: function (ctx, out, p) {   // la firma sonora, riusabile nei reel
                                return Suoni.ricette.melodia(ctx, out, { note: [587.33, 783.99, 880, 1174.66], passo: 0.16,
                                                                          ritardo: p.ritardo, volume: p.volume }); } } });
         S.alVedere('.capitolo', 'pagina');     // un suono quando una sezione entra in vista, una volta
         S.alTocco('.compra', 'goccia');        // un suono al tocco
         S.ambiente('calore', 0.6);             // parla all'ambiente (per esempio dallo scorrimento)
         cartaPausa.onclick = function () { S.pausa(); };   // ferma tutto senza cambiare la scelta di chi legge
       });
     </script>
   Le ricette (Suoni.ricette) sono suoni costruiti dal codice: goccia, carillon, lume, melodia, fruscio,
   pagina, fiammifero, tocco, carta; ambienti: notte (con 'calore'), focolare. Una ricetta e'
   function (ctx, uscita, p) che programma i suoi nodi da ctx.currentTime + p.ritardo e restituisce la durata
   (un ambiente restituisce { imposta, ferma }). La firma sonora si chiama 'firma' (ricetta o file).
   S.tavolozza() dice quali suoni usa la pagina: suono.py ricette li rende in mp3 da ascoltare. */
(function (w) {
  'use strict';
  var AC = w.AudioContext || w.webkitAudioContext;
  var rumori = typeof WeakMap === 'function' ? new WeakMap() : null;

  function rumore(ctx) {
    var b = rumori && rumori.get(ctx);
    if (b) return b;
    var n = Math.floor(ctx.sampleRate * 2);
    b = ctx.createBuffer(1, n, ctx.sampleRate);
    var d = b.getChannelData(0);
    for (var i = 0; i < n; i++) d[i] = Math.random() * 2 - 1;
    if (rumori) rumori.set(ctx, b);
    return b;
  }

  function quando(ctx, p) { return ctx.currentTime + ((p && p.ritardo) || 0); }
  function vol(p) { return p && p.volume != null ? p.volume : 1; }
  function offline(ctx) { return typeof OfflineAudioContext !== 'undefined' && ctx instanceof OfflineAudioContext; }

  // da quasi zero al picco in a secondi, poi giu' in d secondi
  function inviluppo(param, t, picco, a, d) {
    param.setValueAtTime(0.0001, t);
    param.exponentialRampToValueAtTime(Math.max(picco, 0.0002), t + a);
    param.exponentialRampToValueAtTime(0.0001, t + a + d);
  }

  // rumore bianco da t per durata secondi, partendo da un punto a caso del buffer
  function rumoreDa(ctx, t, durata) {
    var s = ctx.createBufferSource();
    s.buffer = rumore(ctx);
    s.start(t, Math.random() * 1.5);
    s.stop(t + Math.min(durata, 0.49) + 0.01);
    return s;
  }

  var R = {};

  // goccia nella pozza: la bolla che sale di tono e un piccolo "plic"
  R.goccia = function (ctx, out, p) {
    var t = quando(ctx, p), k = (p && p.tono) || 1, v = vol(p);
    var o = ctx.createOscillator(), g = ctx.createGain();
    o.type = 'sine';
    o.frequency.setValueAtTime(420 * k, t);
    o.frequency.exponentialRampToValueAtTime(1400 * k, t + 0.04);
    o.frequency.exponentialRampToValueAtTime(1000 * k, t + 0.15);
    inviluppo(g.gain, t, 0.5 * v, 0.004, 0.19);
    o.connect(g); g.connect(out);
    o.start(t); o.stop(t + 0.26);
    var n = rumoreDa(ctx, t, 0.04), f = ctx.createBiquadFilter(), gn = ctx.createGain();
    f.type = 'bandpass'; f.frequency.value = 3400 * k; f.Q.value = 5;
    inviluppo(gn.gain, t, 0.1 * v, 0.001, 0.025);
    n.connect(f); f.connect(gn); gn.connect(out);
    return 0.26;
  };

  // nota di carillon: fondamentale piena, armoniche che si spengono prima
  R.carillon = function (ctx, out, p) {
    p = p || {};
    var t = quando(ctx, p), f = (p.nota || 880) * (p.tono || 1), v = vol(p), lun = p.lunghezza || 1;
    [[1, 0.34, 1.6], [2.0, 0.1, 0.9], [3.01, 0.056, 0.55], [5.4, 0.028, 0.25]].forEach(function (q) {
      if (f * q[0] > 15000) return;
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'sine'; o.frequency.setValueAtTime(f * q[0], t);
      inviluppo(g.gain, t, q[1] * v, 0.003, q[2] * lun);
      o.connect(g); g.connect(out);
      o.start(t); o.stop(t + q[2] * lun + 0.05);
    });
    return 1.65 * lun;
  };

  // il lume che si accende: nota calda e lunga che si apre piano
  R.lume = function (ctx, out, p) {
    p = p || {};
    var t = quando(ctx, p), f = (p.nota || 523.25) * (p.tono || 1), v = vol(p);
    var lp = ctx.createBiquadFilter();
    lp.type = 'lowpass'; lp.Q.value = 0.5;
    lp.frequency.setValueAtTime(900, t); lp.frequency.linearRampToValueAtTime(2600, t + 0.6);
    lp.connect(out);
    [[1, 'triangle', 0.155], [0.5, 'sine', 0.11], [2.0, 'sine', 0.035], [1.5, 'sine', 0.028]].forEach(function (q) {
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = q[1]; o.frequency.setValueAtTime(f * q[0], t);
      o.detune.setValueAtTime((Math.random() - 0.5) * 8, t);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(q[2] * v, t + 0.35);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 2.4);
      o.connect(g); g.connect(lp);
      o.start(t); o.stop(t + 2.5);
    });
    return 2.5;
  };

  // melodia: note in fila con una voce (carillon di serie). note in Hz, 0 = pausa
  R.melodia = function (ctx, out, p) {
    p = p || {};
    var note = p.note || [784, 988, 1175, 1568], passo = p.passo || 0.18, voce = R[p.voce || 'carillon'] || R.carillon;
    var base = p.ritardo || 0, fine = 0;
    note.forEach(function (n, i) {
      if (!n) return;
      var d = voce(ctx, out, { nota: n, ritardo: base + i * passo, volume: (p.volume == null ? 1 : p.volume) * 0.6, lunghezza: p.lunghezza, tono: p.tono });
      fine = Math.max(fine, base + i * passo + d);
    });
    return fine;
  };

  // fruscio di carta: tanti piccoli colpi di rumore filtrato
  R.fruscio = function (ctx, out, p) {
    p = p || {};
    var t = quando(ctx, p), dur = p.durata || 0.32, v = vol(p);
    var n = ctx.createBufferSource(); n.buffer = rumore(ctx);
    var hp = ctx.createBiquadFilter(), bp = ctx.createBiquadFilter(), g = ctx.createGain();
    hp.type = 'highpass'; hp.frequency.value = 1100;
    bp.type = 'bandpass'; bp.frequency.value = 3600 * (p.tono || 1); bp.Q.value = 0.8;
    g.gain.setValueAtTime(0.0001, t);
    var colpi = Math.max(3, Math.floor(dur / 0.026)), sp = dur / colpi;
    for (var i = 0; i < colpi; i++) {
      var ti = t + i * sp + Math.random() * 0.006;
      var a = (0.21 + Math.random() * 0.66) * v * Math.sin(Math.PI * (i + 0.5) / colpi);
      g.gain.setValueAtTime(0.0001, ti);
      g.gain.exponentialRampToValueAtTime(Math.max(a, 0.0002), ti + 0.002);
      g.gain.exponentialRampToValueAtTime(0.0001, ti + 0.01 + Math.random() * 0.006);
    }
    n.connect(hp); hp.connect(bp); bp.connect(g); g.connect(out);
    n.start(t, Math.random() * Math.max(0, 1.85 - dur)); n.stop(t + dur + 0.05);
    return dur + 0.05;
  };

  // pagina che si gira: un soffio che sale e un colpo d'aria alla fine
  R.pagina = function (ctx, out, p) {
    p = p || {};
    var t = quando(ctx, p), v = vol(p), k = p.tono || 1;
    var n = rumoreDa(ctx, t, 0.32), bp = ctx.createBiquadFilter(), g = ctx.createGain();
    bp.type = 'bandpass'; bp.Q.value = 1.2;
    bp.frequency.setValueAtTime(900 * k, t);
    bp.frequency.exponentialRampToValueAtTime(3800 * k, t + 0.22);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.58 * v, t + 0.09);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.3);
    n.connect(bp); bp.connect(g); g.connect(out);
    var n2 = rumoreDa(ctx, t + 0.24, 0.12), lp = ctx.createBiquadFilter(), g2 = ctx.createGain();
    lp.type = 'lowpass'; lp.frequency.value = 420;
    inviluppo(g2.gain, t + 0.24, 0.6 * v, 0.004, 0.07);
    n2.connect(lp); lp.connect(g2); g2.connect(out);
    return 0.4;
  };

  // fiammifero: sfregamento ruvido, poi la fiamma che prende
  R.fiammifero = function (ctx, out, p) {
    p = p || {};
    var t = quando(ctx, p), v = vol(p);
    var n = rumoreDa(ctx, t, 0.12), hp = ctx.createBiquadFilter(), g = ctx.createGain();
    hp.type = 'highpass'; hp.frequency.value = 2400;
    g.gain.setValueAtTime(0.0001, t);
    for (var i = 0; i < 9; i++) {
      var ti = t + i * 0.011;
      g.gain.setValueAtTime(0.0001, ti);
      g.gain.exponentialRampToValueAtTime((0.12 + Math.random() * 0.2) * v, ti + 0.002);
      g.gain.exponentialRampToValueAtTime(0.0001, ti + 0.009);
    }
    n.connect(hp); hp.connect(g); g.connect(out);
    var f = ctx.createBufferSource(); f.buffer = rumore(ctx);
    var bpf = ctx.createBiquadFilter(), gf = ctx.createGain();
    bpf.type = 'bandpass'; bpf.frequency.value = 520; bpf.Q.value = 0.7;
    gf.gain.setValueAtTime(0.0001, t + 0.08);
    gf.gain.exponentialRampToValueAtTime(0.42 * v, t + 0.22);
    gf.gain.exponentialRampToValueAtTime(0.0001, t + 1.25);
    f.connect(bpf); bpf.connect(gf); gf.connect(out);
    f.start(t + 0.08, Math.random() * 0.5); f.stop(t + 1.3);
    return 1.3;
  };

  // tocco di legno: una carta o una pedina posata sul tavolo
  R.tocco = function (ctx, out, p) {
    p = p || {};
    var t = quando(ctx, p), v = vol(p), k = p.tono || 1;
    var o = ctx.createOscillator(), g = ctx.createGain();
    o.type = 'sine';
    o.frequency.setValueAtTime(560 * k, t);
    o.frequency.exponentialRampToValueAtTime(330 * k, t + 0.06);
    inviluppo(g.gain, t, 0.53 * v, 0.002, 0.09);
    o.connect(g); g.connect(out);
    o.start(t); o.stop(t + 0.12);
    var n = rumoreDa(ctx, t, 0.03), lp = ctx.createBiquadFilter(), gn = ctx.createGain();
    lp.type = 'lowpass'; lp.frequency.value = 2200;
    inviluppo(gn.gain, t, 0.3 * v, 0.001, 0.018);
    n.connect(lp); lp.connect(gn); gn.connect(out);
    return 0.12;
  };

  // carta che scivola o si gira (una carta da gioco, un cartoncino)
  R.carta = function (ctx, out, p) {
    p = p || {};
    var t = quando(ctx, p), v = vol(p), k = p.tono || 1;
    var n = rumoreDa(ctx, t, 0.18), bp = ctx.createBiquadFilter(), g = ctx.createGain();
    bp.type = 'bandpass'; bp.Q.value = 1.5;
    bp.frequency.setValueAtTime(1800 * k, t);
    bp.frequency.exponentialRampToValueAtTime(5200 * k, t + 0.12);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.8 * v, t + 0.03);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.15);
    n.connect(bp); bp.connect(g); g.connect(out);
    return 0.2;
  };

  // programmatore per gli ambienti: in diretta guarda avanti 1,2 s ogni 300 ms; offline programma tutto subito
  function programmatore(ctx, p, passo) {
    var attivo = true, timer = null;
    if (offline(ctx)) passo(ctx.currentTime + ((p && p.durata) || 8));
    else {
      passo(ctx.currentTime + 1.2);
      timer = setInterval(function () { if (attivo) passo(ctx.currentTime + 1.2); }, 300);
    }
    return function () { attivo = false; if (timer) clearInterval(timer); };
  }

  function chiudiAmbiente(ctx, bus, sorgenti, fermaProgramma) {
    fermaProgramma();
    var t = ctx.currentTime;
    bus.gain.cancelScheduledValues(t);
    bus.gain.setValueAtTime(Math.max(bus.gain.value, 0.0001), t);
    bus.gain.exponentialRampToValueAtTime(0.0001, t + 0.6);
    setTimeout(function () {
      sorgenti.forEach(function (s) { try { s.stop(); } catch (e) {} });
      try { bus.disconnect(); } catch (e) {}
    }, 700);
  }

  // notte: vento leggero e grilli lontani; ambiente('calore', 0..1) porta una culla calda al posto dei grilli
  R.notte = function (ctx, out, p) {
    p = p || {};
    var t0 = ctx.currentTime, v = vol(p);
    var bus = ctx.createGain();
    bus.gain.setValueAtTime(0.0001, t0); bus.gain.exponentialRampToValueAtTime(v, t0 + 2.5);
    bus.connect(out);
    var vento = ctx.createBufferSource(); vento.buffer = rumore(ctx); vento.loop = true;
    var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 420; lp.Q.value = 0.3;
    var gv = ctx.createGain(); gv.gain.value = 0.12;
    var lfo = ctx.createOscillator(), lg = ctx.createGain(); lfo.frequency.value = 0.07; lg.gain.value = 0.07;
    var lfo2 = ctx.createOscillator(), lg2 = ctx.createGain(); lfo2.frequency.value = 0.045; lg2.gain.value = 160;
    lfo.connect(lg); lg.connect(gv.gain); lfo2.connect(lg2); lg2.connect(lp.frequency);
    vento.connect(lp); lp.connect(gv); gv.connect(bus);
    vento.start(t0, Math.random()); lfo.start(t0); lfo2.start(t0);
    var grilli = ctx.createGain(); grilli.gain.value = 1; grilli.connect(bus);
    function trillo(t, f, pan) {
      var o = ctx.createOscillator(), g = ctx.createGain(), dest = grilli;
      if (ctx.createStereoPanner) { var sp = ctx.createStereoPanner(); sp.pan.value = pan; sp.connect(grilli); dest = sp; }
      o.type = 'sine'; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t);
      for (var i = 0; i < 3; i++) {
        var ti = t + i * 0.032;
        g.gain.setValueAtTime(0.0001, ti);
        g.gain.exponentialRampToValueAtTime(0.06, ti + 0.004);
        g.gain.exponentialRampToValueAtTime(0.0001, ti + 0.02);
      }
      o.connect(g); g.connect(dest);
      o.start(t); o.stop(t + 0.12);
    }
    var prossimo = t0 + 0.4;
    var ferma = programmatore(ctx, p, function (fino) {
      while (prossimo < fino) {
        trillo(prossimo, 4300 + Math.random() * 300, -0.4);
        if (Math.random() < 0.6) trillo(prossimo + 0.21 + Math.random() * 0.1, 4900 + Math.random() * 250, 0.45);
        prossimo += 0.7 + Math.random() * 0.9;
      }
    });
    var culla = ctx.createGain(); culla.gain.value = 0.0001; culla.connect(bus);
    var cf = ctx.createBiquadFilter(); cf.type = 'lowpass'; cf.frequency.value = 1100; cf.connect(culla);
    var voci = [261.63, 329.63, 392.0, 523.25].map(function (f, i) {
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = i % 2 ? 'sine' : 'triangle'; o.frequency.value = f; o.detune.value = (i - 1.5) * 4;
      g.gain.value = 0.05; o.connect(g); g.connect(cf); o.start(t0);
      return o;
    });
    return {
      imposta: function (chiave, val) {
        if (chiave !== 'calore') return;
        var t = ctx.currentTime, c = Math.max(0, Math.min(1, +val || 0));
        culla.gain.setTargetAtTime(0.0001 + 0.9 * c, t, 0.4);
        grilli.gain.setTargetAtTime(1 - 0.85 * c, t, 0.4);
      },
      ferma: function () { chiudiAmbiente(ctx, bus, [vento, lfo, lfo2].concat(voci), ferma); }
    };
  };

  // focolare: brace bassa e scoppiettii radi
  R.focolare = function (ctx, out, p) {
    p = p || {};
    var t0 = ctx.currentTime, v = vol(p);
    var bus = ctx.createGain();
    bus.gain.setValueAtTime(0.0001, t0); bus.gain.exponentialRampToValueAtTime(v, t0 + 2);
    bus.connect(out);
    var brace = ctx.createBufferSource(); brace.buffer = rumore(ctx); brace.loop = true;
    var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 380;
    var gb = ctx.createGain(); gb.gain.value = 0.24;
    brace.connect(lp); lp.connect(gb); gb.connect(bus);
    brace.start(t0, Math.random());
    var prossimo = t0 + 0.3;
    var ferma = programmatore(ctx, p, function (fino) {
      while (prossimo < fino) {
        var n = rumoreDa(ctx, prossimo, 0.03), hp = ctx.createBiquadFilter(), g = ctx.createGain();
        hp.type = 'highpass'; hp.frequency.value = 1500 + Math.random() * 2000;
        inviluppo(g.gain, prossimo, 0.08 + Math.random() * 0.3, 0.001, 0.012 + Math.random() * 0.03);
        n.connect(hp); hp.connect(g); g.connect(bus);
        prossimo += 0.12 + Math.random() * 0.8;
      }
    });
    return { imposta: function () {}, ferma: function () { chiudiAmbiente(ctx, bus, [brace], ferma); } };
  };

  function crea(o) {
    o = o || {};
    var opz = {
      interruttore: o.interruttore || '[data-suono-interruttore]',
      volume: o.volume == null ? 0.8 : o.volume,
      volumeAmbiente: o.volumeAmbiente == null ? 0.35 : o.volumeAmbiente,
      file: o.file || {},
      ricette: o.ricette || {},
      conferma: o.conferma === undefined ? 'lume' : o.conferma,
      ambiente: o.ambiente || null,
      intervallo: o.intervallo == null ? 70 : o.intervallo,
      variazione: o.variazione == null ? 0.04 : o.variazione,
      filtroBassi: o.filtroBassi == null ? 90 : o.filtroBassi
    };
    var ctx = null, master = null, busUi = null, busAmb = null, buffers = {}, caricati = false, amb = null;
    var acceso = false, inPausa = false, ultimo = {}, inAttesa = false, usati = {};
    function segna(nome) { if (typeof nome === 'string' && nome) usati[nome] = true; }
    segna(opz.conferma); segna(opz.ambiente);

    function interruttori() { return Array.prototype.slice.call(document.querySelectorAll(opz.interruttore)); }

    function mostra(stato) {
      interruttori().forEach(function (b) {
        b.setAttribute('aria-pressed', stato ? 'true' : 'false');
        b.setAttribute('data-suono-stato', stato ? 'acceso' : 'spento');
        var ta = b.getAttribute('data-testo-acceso'), ts = b.getAttribute('data-testo-spento');
        if (ta && ts) {
          var dove = b.querySelector('[data-suono-testo]');
          if (dove) dove.textContent = stato ? ta : ts;
          else if (!b.children.length) b.textContent = stato ? ta : ts;
        }
      });
      document.documentElement.setAttribute('data-suoni', stato ? 'acceso' : 'spento');
    }

    function prepara() {
      if (ctx) return true;
      if (!AC) return false;
      try { if (navigator.audioSession) navigator.audioSession.type = 'ambient'; } catch (e) {}
      try { ctx = new AC({ latencyHint: 'interactive' }); } catch (e) { try { ctx = new AC(); } catch (e2) { return false; } }
      master = ctx.createGain(); master.gain.value = 0.0001;
      var hp = ctx.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = opz.filtroBassi; hp.Q.value = 0.5;
      var comp = ctx.createDynamicsCompressor();
      comp.threshold.value = -14; comp.knee.value = 8; comp.ratio.value = 4; comp.attack.value = 0.003; comp.release.value = 0.2;
      busUi = ctx.createGain(); busUi.gain.value = 1;
      busAmb = ctx.createGain(); busAmb.gain.value = opz.volumeAmbiente;
      busUi.connect(master); busAmb.connect(master); master.connect(hp); hp.connect(comp); comp.connect(ctx.destination);
      // sblocco per i Safari vecchi: un campione muto suonato dentro il gesto
      try { var s = ctx.createBufferSource(); s.buffer = ctx.createBuffer(1, 1, 22050); s.connect(master); s.start(0); } catch (e) {}
      return true;
    }

    function carica() {
      if (caricati) return;
      caricati = true;
      Object.keys(opz.file).forEach(function (nome) {
        fetch(opz.file[nome])
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.arrayBuffer(); })
          .then(function (ab) { return new Promise(function (ok, ko) { var pr = ctx.decodeAudioData(ab, ok, ko); if (pr && pr.then) pr.then(ok, ko); }); })
          .then(function (b) { buffers[nome] = b; })
          .catch(function (e) { if (w.console) console.warn('suoni: file non caricato', nome, e); });
      });
    }

    function sfuma(val, tau) {
      var t = ctx.currentTime;
      master.gain.cancelScheduledValues(t);
      master.gain.setTargetAtTime(Math.max(val, 0.0001), t, tau);
    }

    function avviaAmbiente() {
      if (amb || !opz.ambiente) return;
      var f = typeof opz.ambiente === 'function' ? opz.ambiente : (opz.ricette[opz.ambiente] || R[opz.ambiente]);
      if (f) amb = f(ctx, busAmb, {}) || null;
    }
    function fermaAmbiente() { if (amb && amb.ferma) amb.ferma(); amb = null; }

    function accendi(conConferma) {
      if (!prepara()) return Promise.resolve(false);
      acceso = true; inPausa = false; mostra(true);
      var r;
      try { r = ctx.resume(); } catch (e) { r = null; }
      return Promise.resolve(r).then(function () {
        if (!acceso) return false;
        sfuma(opz.volume, 0.08);
        carica(); avviaAmbiente();
        if (conConferma !== false && opz.conferma) suona(opz.conferma, { forza: true });
        try { document.dispatchEvent(new CustomEvent('suoni:acceso')); } catch (e) {}
        return true;
      }, function () { return false; });
    }

    function spegni() {
      acceso = false; mostra(false);
      if (!ctx) return;
      sfuma(0.0001, 0.04);
      var c = ctx;
      setTimeout(function () { if (!acceso) { fermaAmbiente(); if (c.state === 'running') Promise.resolve(c.suspend()).then(null, function () {}); } }, 300);
      try { document.dispatchEvent(new CustomEvent('suoni:spento')); } catch (e) {}
    }

    function alterna() { if (acceso) { spegni(); return Promise.resolve(false); } return accendi(true); }

    // un comando che ferma tutto: tutto zitto senza cambiare la scelta di chi legge
    function pausa() {
      inPausa = true;
      if (ctx && acceso) {
        sfuma(0.0001, 0.04);
        setTimeout(function () { if (inPausa && ctx.state === 'running') Promise.resolve(ctx.suspend()).then(null, function () {}); }, 250);
      }
    }
    function riprendi() {
      inPausa = false;
      if (ctx && acceso) Promise.resolve(ctx.resume()).then(function () { if (acceso && !inPausa) sfuma(opz.volume, 0.12); }, function () { attendiGesto(); });
    }

    function attendiGesto() {
      if (inAttesa) return;
      inAttesa = true;
      var f = function () {
        inAttesa = false;
        w.removeEventListener('pointerdown', f, true); w.removeEventListener('keydown', f, true);
        if (acceso && !inPausa && ctx) Promise.resolve(ctx.resume()).then(function () { sfuma(opz.volume, 0.15); }, function () {});
      };
      w.addEventListener('pointerdown', f, true); w.addEventListener('keydown', f, true);
    }

    function suona(nome, p) {
      p = p || {};
      segna(nome);
      if (!acceso || inPausa || !ctx || ctx.state !== 'running') return false;
      var ora = (w.performance && performance.now()) || Date.now();
      if (!p.forza && ultimo[nome] && ora - ultimo[nome] < (p.intervallo || opz.intervallo)) return false;
      // piccole differenze di tono e volume a ogni colpo, tranne le melodie (la firma resta intonata)
      var v = (p.esatto || nome === 'melodia') ? 0 : opz.variazione, tono = (p.tono || 1) * (1 + (Math.random() * 2 - 1) * v);
      var forza = (p.volume == null ? 1 : p.volume) * (1 + (Math.random() * 2 - 1) * v * 3);
      var out = ctx.createGain(); out.gain.value = forza; out.connect(busUi);
      var durata;
      if (buffers[nome]) {
        var s = ctx.createBufferSource(); s.buffer = buffers[nome]; s.playbackRate.value = tono;
        s.connect(out); s.start(ctx.currentTime + (p.ritardo || 0));
        durata = buffers[nome].duration / tono + (p.ritardo || 0);
      } else {
        var f = opz.ricette[nome] || R[nome];
        if (!f) { try { out.disconnect(); } catch (e) {} return false; }
        var pp = {}; for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) pp[k] = p[k];
        pp.tono = tono; pp.volume = 1;
        durata = f(ctx, out, pp) || 1;
      }
      ultimo[nome] = ora;
      setTimeout(function () { try { out.disconnect(); } catch (e) {} }, (durata + 0.5) * 1000);
      return true;
    }

    // un suono quando l'elemento entra in vista: una volta sola, ma solo dopo che ha suonato davvero
    // (le sezioni viste a suoni spenti suonano quando ci si torna); di serie al massimo uno ogni 500 ms
    function alVedere(sel, nome, p) {
      var q = { intervallo: 500 }, k;
      for (k in p || {}) if (Object.prototype.hasOwnProperty.call(p, k)) q[k] = p[k];
      segna(nome);
      if (!('IntersectionObserver' in w)) return;
      var io = new IntersectionObserver(function (voci) {
        voci.forEach(function (x) {
          if (!x.isIntersecting) return;
          if (suona(nome, q) && q.unaVolta !== false) io.unobserve(x.target);
        });
      }, { threshold: q.soglia || 0.35 });
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) { io.observe(el); });
    }

    function alTocco(sel, nome, p) {
      segna(nome);
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest(sel)) suona(nome, p);
      });
    }

    // si zittisce quando si cambia app o scheda, e riparte solo se era acceso
    document.addEventListener('visibilitychange', function () {
      if (!ctx) return;
      if (document.hidden) {
        if (ctx.state === 'running') {
          sfuma(0.0001, 0.03);
          setTimeout(function () { if (document.hidden && ctx.state === 'running') Promise.resolve(ctx.suspend()).then(null, function () {}); }, 120);
        }
      } else if (acceso && !inPausa) {
        Promise.resolve(ctx.resume()).then(function () { sfuma(opz.volume, 0.15); }, function () {});
        setTimeout(function () { if (acceso && !inPausa && ctx.state !== 'running') attendiGesto(); }, 400);
      }
    });
    w.addEventListener('pagehide', function () { if (ctx && ctx.state === 'running') Promise.resolve(ctx.suspend()).then(null, function () {}); });

    function aggancia() {
      var lista = interruttori();
      lista.forEach(function (b) {
        if (b.__suoni) return;
        b.__suoni = true;
        if (!b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', 'false');
        if (b.tagName === 'BUTTON' && !b.getAttribute('type')) b.setAttribute('type', 'button');
        b.addEventListener('click', function (e) { e.preventDefault(); alterna(); });
      });
      mostra(acceso);
      if (!AC) lista.forEach(function (b) { b.hidden = true; });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aggancia); else aggancia();

    var api = {
      accendi: function () { return accendi(true); },
      spegni: spegni, alterna: alterna, suona: suona, pausa: pausa, riprendi: riprendi,
      alVedere: alVedere, alTocco: alTocco, aggancia: aggancia,
      ambiente: function (chiave, val) { if (amb && amb.imposta) amb.imposta(chiave, val); },
      stato: function () { return { acceso: acceso, pausa: inPausa, contesto: ctx ? ctx.state : 'nessuno', file: Object.keys(buffers), ambiente: !!amb }; },
      contesto: function () { return ctx; },
      // i suoni che la pagina usa (piu' la firma) con ricette, file e livelli: per suono.py ricette
      tavolozza: function () {
        var m = {}, k, nomi = Object.keys(usati);
        for (k in R) m[k] = R[k];
        for (k in opz.ricette) if (Object.prototype.hasOwnProperty.call(opz.ricette, k)) m[k] = opz.ricette[k];
        if ((m.firma || opz.file.firma) && nomi.indexOf('firma') < 0) nomi.push('firma');
        return { nomi: nomi, ricette: m, file: opz.file, volume: opz.volume, volumeAmbiente: opz.volumeAmbiente, filtroBassi: opz.filtroBassi };
      }
    };
    w.__suoni = api;
    return api;
  }

  w.Suoni = { crea: crea, ricette: R, rumore: rumore, inviluppo: inviluppo };
})(window);
